import { useTranslation } from 'react-i18next';
import { estApiError } from '../../api/errors.js';
export function ErreurRdv({ erreur }: { erreur: unknown }) {
  const { t } = useTranslation('regie');
  if (!erreur) return null;
  return (
    <p role="alert">
      {t(
        estApiError(erreur) && erreur.status === 409
          ? 'priseRendezVous.conflit'
          : 'priseRendezVous.erreur',
      )}
    </p>
  );
}
